import { computed, IComputedValue } from 'mobx';
import type { HotkeyCommand } from 'owa-hotkeys';
import { getCommands } from 'owa-mail-hotkeys/lib/utils/MailModuleHotKeys';
import { convertHotkeyToReadableText } from 'owa-readable-hotkeys/lib/utils/convertHotkeyToReadableText';
import type { RibbonControlId } from 'owa-ribbon-ids';
import { MailRibbonControlId } from 'owa-ribbon-ids';

/**
 * OWA/Monarch does not localize shortcut keys currently. However, there
 * are four (soon to be five) sets: Outlook.com, Google, Yahoo!, Outlook,
 * and win32. If/when those are supported, we'll have to have a more
 * complicated mapping.
 */

const controlHotkeyMap: IComputedValue<Map<RibbonControlId, HotkeyCommand>> = computed(() => {
    const commands = getCommands();

    /**
     * There IS a hotkey for toggling the flag (command.toggleFlag), but it swaps between
     * Flagged and Completed Flag, not Flagged and Unflagged.  We will leave it out of
     * the tooltip, as win32, so as not to cause confusion.
     */
    const controlMap = new Map<RibbonControlId, HotkeyCommand>()
        .set(MailRibbonControlId.Archive, commands.archiveMail)
        .set(MailRibbonControlId.Categorize, commands.categorize)
        .set(MailRibbonControlId.DeleteItem, commands.deleteMail)
        .set(MailRibbonControlId.DiscardDraft, commands.discardDraft)
        .set(MailRibbonControlId.IgnoreStopIgnore, commands.ignore)
        .set(MailRibbonControlId.JunkNotJunk, commands.markAsJunk)
        .set(MailRibbonControlId.Move, commands.moveToFolder)
        .set(MailRibbonControlId.NewMessageSplitButton, commands.newMail)
        .set(MailRibbonControlId.ReadUnread, commands.markAsReadUnread)
        .set(MailRibbonControlId.RespondForward, commands.forward)
        .set(MailRibbonControlId.RespondReply, commands.reply)
        .set(MailRibbonControlId.RespondReplyAll, commands.replyAll)
        .set(MailRibbonControlId.Save, commands.saveDraft)
        .set(MailRibbonControlId.SendDraft, commands.sendMail)
        .set(MailRibbonControlId.ShowLinkDialog, commands.insertHyperlink)
        .set(MailRibbonControlId.Snooze, commands.snooze)
        .set(MailRibbonControlId.Undo, commands.undoAction);

    return controlMap;
});

export function getHoverTooltipHotkey(controlId: RibbonControlId): string | undefined {
    const hotkeySet: HotkeyCommand | undefined = controlHotkeyMap.get().get(controlId);

    return hotkeySet ? convertHotkeyToReadableText(hotkeySet) : undefined;
}
